import dynamic from 'next/dynamic';

export const SearchDebugPanel = dynamic(
  () => import(/* webpackChunkName: 'SearchDebugPanel' */ './SearchDebugPanel'),
  { ssr: false },
);
